// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageBox_image__1MPg1"};